// Lojas Triângulo — PDP: galeria, sticky bar, cálculo de frete, recently viewed.
(function () {
  'use strict';

  function onIdle(fn) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(fn, { timeout: 2500 });
    } else {
      window.addEventListener('load', function () { window.setTimeout(fn, 600); }, { once: true });
    }
  }

  // Galeria PDP: lazy video, thumbs mobile, sync scroll↔thumbs.
  (function gallery(){
    var track = document.querySelector('[data-gallery-track]');
    if(!track) return;
    var cells = Array.prototype.slice.call(track.querySelectorAll('.tri-pdp__cell'));
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-thumb-index]'));
    // Lazy-load HTML5 videos quando entram no viewport; pausa ao sair.
    if('IntersectionObserver' in window){
      var vio = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          var v = e.target;
          if(e.isIntersecting){
            if(!v.src && v.dataset.src){ v.src = v.dataset.src; v.load(); }
            var p = v.play(); if(p && p.catch) p.catch(function(){});
          } else {
            if(!v.paused) v.pause();
          }
        });
      }, { rootMargin: '200px 0px' });
      track.querySelectorAll('video[data-lazy-video]').forEach(function(v){ vio.observe(v); });
    }
    // Vídeos externos (YouTube/Vimeo): injeta iframe só no clique.
    track.querySelectorAll('[data-play-external]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var host = btn.dataset.host, id = btn.dataset.embed;
        var src = host === 'youtube'
          ? 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0'
          : 'https://player.vimeo.com/video/' + id + '?autoplay=1';
        var iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.setAttribute('allow','autoplay; encrypted-media; picture-in-picture');
        iframe.setAttribute('allowfullscreen','');
        iframe.style.cssText = 'width:100%;aspect-ratio:4/5;border:0;display:block';
        btn.replaceWith(iframe);
      });
    });
    // Thumbs (mobile) → scroll para o slide; sincroniza estado ativo.
    if(thumbs.length && cells.length){
      thumbs.forEach(function(t){
        t.addEventListener('click', function(){
          var i = parseInt(t.dataset.thumbIndex || '0', 10);
          var cell = cells[i]; if(!cell) return;
          cell.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
      });
      if('IntersectionObserver' in window){
        var pendingIdx = null, rafId = 0;
        var apply = function(){
          rafId = 0;
          if(pendingIdx === null) return;
          var i = pendingIdx; pendingIdx = null;
          thumbs.forEach(function(t){
            t.classList.toggle('is-active', parseInt(t.dataset.thumbIndex,10) === i);
          });
        };

        var cio = new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            if(e.intersectionRatio < 0.6) return;
            pendingIdx = parseInt(e.target.dataset.index || '0', 10);
          });
          if(!rafId) rafId = requestAnimationFrame(apply);
        }, { root: track, threshold: [0.6] });
        cells.forEach(function(c){ cio.observe(c); });
      }
    }
  })();

  // Botões quantidade.
  var qtyEls = document.querySelectorAll('[data-qty]');
  qtyEls.forEach(function (root) {
    var input = root.querySelector('input');
    root.querySelector('[data-dec]').addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    root.querySelector('[data-inc]').addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) + 1);
    });
  });

  // Máscara CEP + cálculo (usa /cart/shipping_rates.json).
  var cepInput = document.querySelector('[data-cep]');
  var calcBtn = document.querySelector('[data-shipping-calc]');
  var geoBtn = document.querySelector('[data-shipping-geo]');
  var result = document.querySelector('[data-shipping-result]');

  function maskCep(v) {
    var d = (v || '').replace(/\D/g, '').slice(0, 8);
    return d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
  }

  function fmtPrice(v) {
    var n = parseFloat(v);
    if (!n) return 'GRÁTIS';
    return 'R$ ' + n.toFixed(2).replace('.', ',');
  }

  function renderRates(rates, loc) {
    if (!result) return;
    result.hidden = false;
    result.innerHTML = '';
    if (loc && (loc.city || loc.uf)) {
      var head = document.createElement('div');
      head.className = 'tri-shipping__location';
      head.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 22s-7-7.5-7-13a7 7 0 1 1 14 0c0 5.5-7 13-7 13z"/><circle cx="12" cy="9" r="2.5"/></svg>' +
        '<span>' + [loc.city, loc.uf].filter(Boolean).join(', ') + '</span>';
      result.appendChild(head);
    }
    var ul = document.createElement('ul');
    ul.className = 'tri-shipping__rates';
    if (!rates || !rates.length) {
      var li0 = document.createElement('li');
      li0.className = 'tri-shipping__rate tri-shipping__rate--empty';
      li0.textContent = 'Não foi possível obter cotações para este CEP.';
      ul.appendChild(li0);
      result.appendChild(ul);
      return;
    }
    rates.sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
    rates.slice(0, 4).forEach(function (r) {
      var li = document.createElement('li');
      li.className = 'tri-shipping__rate';
      var info = document.createElement('div');
      info.className = 'tri-shipping__rate-info';
      var name = document.createElement('strong');
      name.textContent = r.name || r.presentment_name || 'Entrega';
      var eta = document.createElement('span');
      var etaText = 'Consulte prazo';
      var dMin = null, dMax = null;
      if (r.delivery_days && r.delivery_days.length) {
        dMin = parseInt(r.delivery_days[0], 10);
        dMax = parseInt(r.delivery_days[1] != null ? r.delivery_days[1] : r.delivery_days[0], 10);
      } else if (typeof r.delivery_days === 'number') {
        dMin = dMax = r.delivery_days;
      } else if (r.min_delivery_date && r.max_delivery_date) {
        var today = new Date(); today.setHours(0,0,0,0);
        var dA = new Date(r.min_delivery_date), dB = new Date(r.max_delivery_date);
        dMin = Math.max(1, Math.ceil((dA - today) / 86400000));
        dMax = Math.max(1, Math.ceil((dB - today) / 86400000));
      }
      if (dMin != null && dMax != null && !isNaN(dMin) && !isNaN(dMax)) {
        etaText = (dMin === dMax)
          ? ('Em até ' + dMax + ' dias úteis')
          : ('Entrega em ' + dMin + ' a ' + dMax + ' dias úteis');
      }
      eta.textContent = etaText;
      info.appendChild(name);
      info.appendChild(eta);
      var price = document.createElement('b');
      var isFree = parseFloat(r.price) === 0;
      price.textContent = isFree ? 'GRÁTIS' : fmtPrice(r.price);
      if (isFree) price.className = 'is-free';
      li.appendChild(info);
      li.appendChild(price);
      ul.appendChild(li);
    });
    result.appendChild(ul);
  }
  function resolveCep(zip) {
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 2500) : null;
    return fetch('https://brasilapi.com.br/api/cep/v1/' + zip, ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) { if (timer) clearTimeout(timer); if (!r.ok) throw new Error('brasilapi'); return r.json(); })
      .then(function (d) { return { uf: d.state, city: d.city }; })
      .catch(function () {
        return fetch('https://viacep.com.br/ws/' + zip + '/json/')
          .then(function (r) { return r.json(); })
          .then(function (d) { if (!d || d.erro) throw new Error('viacep'); return { uf: d.uf, city: d.localidade }; });
      });
  }

  function currentVariantId() {
    var input = document.querySelector('form[data-product-form] [data-variant-id-input]');
    return input ? input.value : null;
  }

  // Os endpoints não documentados prepare_shipping_rates/async_shipping_rates
  // cotam o carrinho atual, não o produto da página. Se o carrinho estiver
  // vazio a Shopify responde 422 "Este carrinho não exige frete", então
  // adicionamos a variante temporariamente antes de cotar e desfazemos depois.
  function ensureCartItemForQuote() {
    var variantId = currentVariantId();
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.item_count > 0) return null;
        if (!variantId) return null;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (item) { return item ? variantId : null; })
          .catch(function () { return null; });
      });
  }

  function releaseTempCartItem(tempVariantId) {
    if (!tempVariantId) return Promise.resolve();
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: tempVariantId, quantity: 0 })
    }).catch(function () {});
  }

  function fetchRatesAsync(zip, province) {
    var qs = 'shipping_address[zip]=' + encodeURIComponent(zip) +
             '&shipping_address[country]=BR' +
             (province ? '&shipping_address[province]=' + encodeURIComponent(province) : '');

    var tempVariantId = null;
    return ensureCartItemForQuote()
      .then(function (addedVariantId) {
        tempVariantId = addedVariantId;
        return fetch('/cart/prepare_shipping_rates.json?' + qs, { method: 'POST' });
      })
      .then(function () {
        var attempts = 0;
        return new Promise(function (resolve, reject) {
          (function poll() {
            attempts++;
            fetch('/cart/async_shipping_rates.json?' + qs)
              .then(function (r) { return r.json(); })
              .then(function (data) {
                if (data && data.shipping_rates) return resolve(data.shipping_rates);
                if (attempts > 10) return reject(new Error('timeout'));
                setTimeout(poll, 500);
              })
              .catch(reject);
          })();
        });
      })
      .then(function (rates) {
        return releaseTempCartItem(tempVariantId).then(function () { return rates; });
      })
      .catch(function (err) {
        return releaseTempCartItem(tempVariantId).then(function () { throw err; });
      });
  }
  function calcShipping(zip) {
    if (!result) return;
    result.hidden = false;
    result.innerHTML = '<div class="tri-shipping__loading">Consultando…</div>';
    resolveCep(zip)
      .then(function (loc) {
        return fetchRatesAsync(zip, loc.uf).then(function (rates) { renderRates(rates || [], loc); });
      })
      .catch(function () {
        // Fallback sem província (funciona em alguns setups).
        fetchRatesAsync(zip, null)
          .then(function (rates) { renderRates(rates || [], null); })
          .catch(function () {
            result.innerHTML = '<div class="tri-shipping__loading">Não foi possível calcular agora. Tente novamente.</div>';
          });
      });
  }

  if (cepInput) {
    cepInput.addEventListener('input', function () { cepInput.value = maskCep(cepInput.value); });
  }
  if (calcBtn && cepInput) {
    calcBtn.addEventListener('click', function () {
      var clean = (cepInput.value || '').replace(/\D/g, '');
      if (clean.length !== 8) {
        if (result) { result.hidden = false; result.innerHTML = '<li>Informe um CEP válido (8 dígitos).</li>'; }
        return;
      }
      calcShipping(clean);
    });
  }
  if (geoBtn && cepInput && 'geolocation' in navigator) {
    geoBtn.addEventListener('click', function () {
      if (result) { result.hidden = false; result.innerHTML = '<li>Localizando…</li>'; }
      navigator.geolocation.getCurrentPosition(function (pos) {
        fetch('https://nominatim.openstreetmap.org/reverse?format=json&lat=' + pos.coords.latitude + '&lon=' + pos.coords.longitude)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var zip = (data && data.address && data.address.postcode) ? data.address.postcode.replace(/\D/g, '') : '';
            if (zip.length === 8) {
              cepInput.value = maskCep(zip);
              calcShipping(zip);
            } else if (result) {
              result.innerHTML = '<li>Não conseguimos identificar seu CEP. Digite manualmente.</li>';
            }
          })
          .catch(function () {
            if (result) result.innerHTML = '<li>Não foi possível localizar. Digite o CEP manualmente.</li>';
          });
      }, function () {
        if (result) result.innerHTML = '<li>Permissão de localização negada.</li>';
      });
    });
  }

  // Sticky buy bar.
  var stickyBar = document.querySelector('[data-sticky-bar]');
  var buyRef = document.querySelector('.tri-pdp__buy');
  if (stickyBar && buyRef && 'IntersectionObserver' in window) {
    stickyBar.hidden = false;
    var stickyBtn = stickyBar.querySelector('[data-sticky-buy]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var submit = document.querySelector('.tri-pdp__form button[type="submit"]');
        if (submit) submit.click();
      });
    }
    var so = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var above = !e.isIntersecting && e.boundingClientRect.top < 0;
        requestAnimationFrame(function(){
          stickyBar.classList.toggle('is-visible', above);
        });
      });
    });
    so.observe(buyRef);
  }

  // Recently viewed (localStorage) não é necessário para o primeiro paint.
  onIdle(function(){
    try {
      var pdp = document.querySelector('.tri-pdp[data-atc]');
      if (pdp) {
        var atc = JSON.parse(pdp.getAttribute('data-atc') || '{}');
        var key = 'tri:recent';
        var arr = [];
        try { arr = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) {}
        arr = arr.filter(function (i) { return i.id !== atc.item_id; });
        arr.unshift({ id: atc.item_id, name: atc.item_name, price: atc.price, url: location.pathname });
        localStorage.setItem(key, JSON.stringify(arr.slice(0, 8)));
      }
    } catch (e) {}
  });

  // Sincroniza variante selecionada: id, preço, PIX, parcelas, estoque, sticky.
  (function syncVariant(){
    var form = document.querySelector('form[data-product-form]');
    if(!form) return;
    var idInput = form.querySelector('[data-variant-id-input]');
    var dataEl = form.querySelector('[data-product-variants-json]');
    if(!idInput || !dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent || '[]'); } catch(e){ return; }
    if(!variants.length) return;
    var priceBlock = document.querySelector('[data-price-block]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stockEl = document.querySelector('[data-stock]');
    function currentOptions(){
      var opts = [];
      form.querySelectorAll('input[type="radio"][name^="options["]:checked').forEach(function(r){
        opts.push(r.value);
      });
      return opts;
    }
    function updateOptionAvailability() {
      var selectedOptions = currentOptions();

      var optionGroups = Array.from(
        form.querySelectorAll('.tri-pdp__opt')
      );

      optionGroups.forEach(function(group, optionIndex) {
        var radios = group.querySelectorAll(
          'input[type="radio"][name^="options["]'
        );

        radios.forEach(function(radio) {
          var candidateOptions = selectedOptions.slice();

          candidateOptions[optionIndex] = radio.value;

          var availableVariant = variants.some(function(variant) {
            if (!variant.available) return false;

            return variant.options.every(function(optionValue, index) {
              /*
              * Para opções anteriores e para a opção atual,
              * exige correspondência exata.
              *
              * Para opções posteriores ainda não selecionadas,
              * permite qualquer valor.
              */
              var candidateValue = candidateOptions[index];

              return !candidateValue || optionValue === candidateValue;
            });
          });

          var label = radio.closest('.tri-chip');

          if (!label) return;

          label.classList.toggle('tri-instock', availableVariant);
          label.classList.toggle('tri-outstock', !availableVariant);

          // radio.disabled = !availableVariant;

          // radio.setAttribute(
          //   'aria-disabled',
          //   availableVariant ? 'false' : 'true'
          // );
        });
      });
    }
    function applyPricing(v){
      if(priceBlock){
        var now = priceBlock.querySelector('[data-price-now]');
        if(now) now.textContent = v.price_formatted;
        var old = priceBlock.querySelector('[data-price-old]');
        if(old){
          if(v.on_sale){
            old.hidden = false;
            var oldVal = old.querySelector('[data-price-old-value]');
            if(oldVal) oldVal.textContent = v.compare_at_formatted;
          } else {
            old.hidden = true;
          }
        }
        var disc = priceBlock.querySelector('[data-price-discount]');
        if(disc){
          if(v.desconto_pct > 0){
            disc.hidden = false;
            var dv = disc.querySelector('[data-price-discount-value]');
            if(dv) dv.textContent = v.desconto_pct;
          } else {
            disc.hidden = true;
          }
        }
        var instVal = priceBlock.querySelector('[data-price-installments-value]');
        if(instVal) instVal.textContent = v.parcela_formatted;
        var pixVal = priceBlock.querySelector('[data-price-pix-value]');
        if(pixVal) pixVal.textContent = v.pix_formatted;
      }
      if(stickyPrice) stickyPrice.textContent = v.price_formatted;
      if(stockEl){
        var isIn = !!v.available;
        stockEl.classList.toggle('is-in', isIn);
        stockEl.classList.toggle('is-out', !isIn);
        var st = stockEl.querySelector('[data-stock-text]');
        if(st) st.textContent = isIn
          ? (stockEl.getAttribute('data-stock-in') || '')
          : (stockEl.getAttribute('data-stock-out') || '');
      }
    }
    function update(){
      var sel = currentOptions();
      if(!sel.length) return;
      updateOptionAvailability();
      var match = variants.find(function(vt){
        return vt.options.length === sel.length && vt.options.every(function(o,i){ return o === sel[i]; });
      });
      if(!match) return;
      idInput.value = match.id;
      var btn = form.querySelector('button[type="submit"]');
      if(btn){
        if(!match.available){ btn.setAttribute('disabled','disabled'); btn.textContent = 'INDISPONÍVEL'; }
        else {
          btn.removeAttribute('disabled');
          const texto = btn.getAttribute('data-text-btn');
          btn.textContent = texto;
        }
      }
      applyPricing(match);
      // URL nativo estilo Dawn
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      } catch(e){}
    }
    form.addEventListener('change', function(e){
      if(e.target && e.target.matches('input[type="radio"][name^="options["]')) update();
    });
    update();
  })();
})();
